import { HttpStatusCode } from "axios";

export interface ErrorResponse<T> {
  message: string;
  code?: string;
  response?: {
    data: T;
    status: number;
    statusText: string;
  };
}

export enum ErrorCode {
  NetworkError = "NetworkError",
  ServerError = "ServerError",
}

export const isServerError = (status: number) =>
  status >= HttpStatusCode.InternalServerError;
